import React from 'react';
import StrapiDescription from '../StrapiDescription';
import classnames from 'classnames';

interface IStrapiBannerDescriptionProps {
  shortDescription: string;
  description: string;
  hidden: boolean;
  isCustomLandingPage?: boolean;
}
const StrapiBannerDescription = ({
  shortDescription,
  description,
  hidden,
  isCustomLandingPage = false,
}: IStrapiBannerDescriptionProps) => {
  if (!shortDescription && !description) {
    return null;
  }

  if (shortDescription) {
    return (
      <p
        className={classnames({
          description: true,
          landingpage: isCustomLandingPage,
        })}
      >
        {shortDescription}
      </p>
    );
  }

  if (description) {
    return (
      <StrapiDescription
        description={description}
        hidden={hidden}
        htmlRegexPattern={/<\/?(?!a)\w*\b[^>]*>/gi}
        className={isCustomLandingPage ? 'landingpage' : ''}
      />
    );
  }

  return null;
};

export default StrapiBannerDescription;
